import React from 'react';
import { ORDER_LIST_TABS } from '@/apis/settlement/interface';
import styled from 'styled-components';

interface Props {
  tabs: Array<typeof ORDER_LIST_TABS[keyof typeof ORDER_LIST_TABS]>;
  selectedTab: ORDER_LIST_TABS;
  onSelectTab: (selectTab: ORDER_LIST_TABS) => void;
}

const OrderTabs = ({ tabs, selectedTab, onSelectTab }: Props) => {
  return (
    <TabContainer>
      {tabs.map(orderTab => (
        <Tab
          key={orderTab.tabKey}
          onClick={() => onSelectTab(orderTab.tabKey)}
          selected={selectedTab === orderTab.tabKey}>
          {orderTab.tabName}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default OrderTabs;

const TabContainer = styled.section`
  position: absolute;
  top: 5px;
  display: flex;
  align-items: center;
`;

const Tab = styled.div<{ selected: boolean }>`
  width: fit-content;
  padding: 13px 45px 10px;
  font-size: 16px;
  line-height: 19px;
  font-weight: 600;
  background: ${({ selected }) => (selected ? '#ffffff' : '#efefef')};
  cursor: pointer;
`;
